import * as data from '../../json/seoData.json';

export const seoMapperConstant = {
  TYPE_KEY: 'jenis_reksadana',
  PRODUCT_KEY: 'produk',
  INVESTMENT_MANAGER_KEY: 'manajer_investasi',
  SYARIAH_KEY: 'reksa_dana_syariah',
  CUSTODIAN_BANK_KEY: 'bank_kustodian',
};

const getSeoData = type => data.seo_data[type];

const getSeoObject = (type, child = '') => {
  const key = { key: child };
  let seoData = getSeoData(type);
  if (child) {
    seoData = seoData.data[child];
  }
  return Object.assign(key, seoData);
};

const mutualFundTypeList = [
  {
    route: 'pasar-uang',
    value: 'Pasar Uang',
    key: 'pasar_uang',
  },
  {
    route: 'pendapatan-tetap',
    value: 'Pendapatan Tetap',
    key: 'pendapatan_tetap',
  },
  {
    route: 'campuran',
    value: 'Campuran',
    key: 'campuran',
  },
  {
    route: 'saham',
    value: 'Saham',
    key: 'saham',
  },
];

const mutualFundProductList = [
  {
    route: 'reksa-dana-ashmore-dana-obligasi-nusantara',
    value: 'IDN000154309',
    key: 'ashmore_dana_obligasi_nusantara',
  },
  {
    route: 'reksa-dana-syariah-mandiri-bukareksa-pasar-uang',
    value: 'IDN000282506',
    key: 'syariah_mandiri_bukareksa_pasar_uang',
  },
  {
    route: 'cimb-principal-bukareksa-pasar-uang',
    value: 'IDN000265709',
    key: 'cimb_principal_bukareksa_pasar_uang',
  },
  {
    route: 'syailendra-fixed-income-fund',
    value: 'IDN000127602',
    key: 'syailendra_fixed_income_fund',
  },
  {
    route: 'cimb-principal-total-return-bond-fund',
    value: 'IDN000005402',
    key: 'cimb_principal_total_return_bond_fund',
  },
  {
    route: 'mandiri-investa-dana-syariah',
    value: 'IDN000074903',
    key: 'mandiri_investa_dana_syariah',
  },
  {
    route: 'manulife-obligasi-negara-indonesia-ii',
    value: 'IDN000068202',
    key: 'manulife_obligasi_negara_indonesia_ii',
  },
  {
    route: 'bahana-mes-syariah',
    value: 'DX002FISBMSYAR00',
    key: 'bahana_mes_syariah',
  },
  {
    route: 'kresna-flexima',
    value: 'IDN000055902',
    key: 'kresna_flexima',
  },
  {
    route: 'cipta-syariah-balance',
    value: 'IDN000080504',
    key: 'cipta_syariah_balance',
  },
  {
    route: 'schroder-dana-kombinasi',
    value: 'IDN000000205',
    key: 'schroder_dana_kombinasi',
  },
  {
    route: 'schroder-dynamic-balanced-fund',
    value: 'IDN000179108',
    key: 'schroder_dynamic_balanced_fund',
  },
  {
    route: 'batavia-dana-dinamis',
    value: 'BZ002MXCDANDIM00',
    key: 'batavia_dana_dinamis',
  },
  {
    route: 'bnp-paribas-pesona',
    value: 'IDN000019205',
    key: 'bnp_paribas_pesona',
  },
  {
    route: 'bnp-paribas-pesona-syariah',
    value: 'IDN000047107',
    key: 'bnp_paribas_pesona_syariah',
  },
  {
    route: 'bnp-paribas-ekuitas',
    value: 'IDN000038007',
    key: 'bnp_paribas_ekuitas',
  },
  {
    route: 'bnp-paribas-infrastruktur-plus',
    value: 'IDN000045804',
    key: 'bnp_paribas_infrastruktur_plus',
  },
  {
    route: 'manulife-dana-saham',
    value: 'IDN000020302',
    key: 'manulife_dana_saham',
  },
  {
    route: 'batavia-dana-saham',
    value: 'BZ002EQCDANSHM00',
    key: 'batavia_dana_saham',
  },
  {
    route: 'sucorinvest-sharia-equity-fund',
    value: 'GAMA2EQSSEQUIT00',
    key: 'sucorinvest_sharia_equity_fund',
  },
  {
    route: 'sucorinvest-maxi-fund',
    value: 'GAMA2EQCMAXIFU00',
    key: 'sucorinvest_maxi_fund',
  },
  {
    route: 'mandiri-investa-pasar-uang',
    value: 'CC002MMCINVPSU00',
    key: 'mandiri_investa_pasar_uang',
  },
  {
    route: 'sucorinvest-equity-fund',
    value: 'GAMA2EQCEQUITY00',
    key: 'sucorinvest_equity_fund',
  },
  {
    route: 'bnp-paribas-omega',
    value: 'MEES2FICRDFRP200',
    key: 'bnp_paribas_omega',
  },
  {
    route: 'mandiri-investa-equity-asean-5-plus',
    value: 'CC002EQCINVEA500',
    key: 'mandiri_investa_equity_asean_5_plus',
  },
];

const investmentManagerList = [
  {
    route: 'pt-ashmore-asset-management',
    value: 'EL002',
    key: 'ashmore_asset_management',
  },
  {
    route: 'pt-bahana-twc-invesment-management',
    value: 'DX002',
    key: 'bahana_twc_invesment_management',
  },
  {
    route: 'pt-batavia-prosperindo-aset-manajemen',
    value: 'BZ002',
    key: 'batavia_prosperindo_aset_manajemen',
  },
  {
    route: 'pt-bnp-paribas-investment-partners',
    value: 'MEES2',
    key: 'bnp_paribas_investment_partners',
  },
  {
    route: 'pt-cimb-principal-asset-management',
    value: 'ZG002',
    key: 'cimb_principal_asset_management',
  },
  {
    route: 'pt-ciptadana-asset-management',
    value: 'KI002',
    key: 'ciptadana_asset_management',
  },
  {
    route: 'pt-kresna-asset-management',
    value: 'KS002',
    key: 'kresna_asset_management',
  },
  {
    route: 'pt-mandiri-manajemen-investasi',
    value: 'CC002',
    key: 'mandiri_manajemen_investasi',
  },
  {
    route: 'pt-manulife-aset-manajemen-indonesia',
    value: 'MAN02',
    key: 'manulife_aset_manajemen_indonesia',
  },
  {
    route: 'pt-schroder-investment-management-indonesia',
    value: 'SCH02',
    key: 'schroder_investment_management_indonesia',
  },
  {
    route: 'pt-sucorinvest-asset-management',
    value: 'GAMA2',
    key: 'sucorinvest_asset_management',
  },
  {
    route: 'pt-syailendra-capital',
    value: 'SYA02',
    key: 'syailendra_capital',
  },
];

const mutualFundTypeUrlBase = '/bukareksa/jenis-reksa-dana';
const mutualFundProductUrlBase = '/bukareksa/produk';
const investmentManagerUrlBase = '/bukareksa/manajer-investasi';

const findDataFromList = (lookupList, lookupValue, lookupKey = 'key') => {
  let result = null;
  result = lookupList.find(item => {
    if (lookupKey === 'route') {
      return item.value === lookupValue;
    }
    return item.route === lookupValue;
  });

  if (result) {
    if (lookupKey === 'route') {
      return result.route;
    }
    return result.key;
  }
  return '';
};

const generateUrl = (value, type) => {
  let url = '';
  if (type === seoMapperConstant.TYPE_KEY) {
    url = `${mutualFundTypeUrlBase}/${findDataFromList(mutualFundTypeList, value, 'route')}`;
  } else if (type === seoMapperConstant.PRODUCT_KEY) {
    url = `${mutualFundProductUrlBase}/${findDataFromList(mutualFundProductList, value, 'route')}`;
  } else {
    url = `${investmentManagerUrlBase}/${findDataFromList(investmentManagerList, value, 'route')}`;
  }
  return url;
};

export const generateBreadcrumbLinks = (type, key = '') => {
  const breadcrumbLinks = [];

  const parent = getSeoObject(type);

  if (key) {
    breadcrumbLinks.push(parent);
    breadcrumbLinks.push(Object.assign(getSeoObject(type, key), { isActive: true }));
  } else {
    breadcrumbLinks.push(Object.assign(parent, { isActive: true }));
  }

  return breadcrumbLinks;
};

/*
 * product parameter only used for generateOtherLinks for detail product
 * since requirement need other link for detail product only generate product with the same type
 */
export const generateOtherLinks = (key, detail = false, product = false) => {
  let allOtherLinks = [];
  let parentUrl = '';

  let iterator = data.seo_data;
  if (detail) {
    parentUrl = data.seo_data[detail].link_url;
    iterator = data.seo_data[detail].data;
  }

  allOtherLinks = Object.keys(iterator)
    .filter(objectKey => objectKey !== key)
    .reduce((acc, currKey) => {
      const object = iterator[currKey];
      object.link_url = parentUrl + object.link_url;
      if (product) {
        if (object.type === product) {
          acc.push(object);
        }
      } else {
        acc.push(object);
      }
      return acc;
    }, []);

  return allOtherLinks;
};

/*
 * checkRouteExist only used to check the detail/child page
 * parent route should will be check through controller
 */
export const checkRouteExist = (type, detail) => {
  let exist = false;

  if (type === seoMapperConstant.TYPE_KEY) {
    exist = findDataFromList(mutualFundTypeList, detail);
  } else if (type === seoMapperConstant.PRODUCT_KEY) {
    exist = findDataFromList(mutualFundProductList, detail);
  } else if (type === seoMapperConstant.INVESTMENT_MANAGER_KEY) {
    exist = findDataFromList(investmentManagerList, detail);
  }

  return exist;
};

export const generateSeoTypeUrl = mutualFundType => generateUrl(mutualFundType, seoMapperConstant.TYPE_KEY);

export const getMutualFundTypeObject = (mutualFundType = '') =>
  getSeoObject(seoMapperConstant.TYPE_KEY, mutualFundType ? findDataFromList(mutualFundTypeList, mutualFundType) : '');

export const generateSeoProductUrl = mutualFundProduct => generateUrl(mutualFundProduct, seoMapperConstant.PRODUCT_KEY);

export const getMutualFundProductObject = (mutualFundProduct = '') =>
  getSeoObject(
    seoMapperConstant.PRODUCT_KEY,
    mutualFundProduct ? findDataFromList(mutualFundProductList, mutualFundProduct) : '',
  );

export const generateSeoInvestmentManagerUrl = investmentManager =>
  generateUrl(investmentManager, seoMapperConstant.INVESTMENT_MANAGER_KEY);

export const getInvestmentManagerObject = (investmentManager = '') =>
  getSeoObject(
    seoMapperConstant.INVESTMENT_MANAGER_KEY,
    investmentManager ? findDataFromList(investmentManagerList, investmentManager) : '',
  );

export const getSyariahObject = () => getSeoObject(seoMapperConstant.SYARIAH_KEY);

export const getCustodianBankObject = () => getSeoObject(seoMapperConstant.CUSTODIAN_BANK_KEY);

export default {
  generateSeoTypeUrl,
  generateSeoProductUrl,
  generateSeoInvestmentManagerUrl,
  getMutualFundTypeObject,
  getInvestmentManagerObject,
  getMutualFundProductObject,
  getSyariahObject,
  getCustodianBankObject,
  generateOtherLinks,
  checkRouteExist,
  generateBreadcrumbLinks,
  seoMapperConstant,
};
